import * as types from "../types/foods"

const initialState = {}

const foodsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FOODS: {
      const newFoodsMap = {}

      action.foods.forEach(food => {
        newFoodsMap[food._id] = food
      })

      const newState = {
        ...state,
        ...newFoodsMap
      }

      return newState
    }
    case types.UPDATE_FOODS: {
      const newState = { ...state }

      action.foods.forEach(food => {
        newState[food._id] = food
      })

      return newState
    }
    case types.DELETE_FOODS:
      const newState = { ...state }

      action.foodIds.forEach(foodId => {
        delete newState[foodId]
      })

      return newState
    case types.CLEAR_FOODS:
      return null
    default:
      return state
  }
}

export default foodsReducer